<template>
  <div class="commerce-order-help-wall">
    <div v-if="t" class="scroll no-scrollbar">
      <p class="subtitle header has-text-black" @click="$emit('close')">
        <i class="fa fa-chevron-left" style="padding-right: 4px" />
        <i>{{ $t("commerce-order.we-ll-help-with-that") }}</i>
        <span class="is-pulled-right has-text-weight-bold">#{{ fullRef }}</span>
      </p>

      <div v-if="shopContactable" class="notification">
        <p class="subtitle">
          <i class="fa fa-store-alt" />
          {{ $t("commerce-order.contact-the-shop") }}
        </p>
        <p>
          {{ $t("commerce-order.tell-them-its") }}
          <span class="has-text-weight-medium">TUK Order #{{ t.data.ref }}</span>
        </p>
        <p class="hint">
          <i>{{ $t("commerce-order.best-option-when") }}</i>
        </p>

        <a class="button is-fullwidth is-link is-outlined" @click="callShop">
          <i class="fa fa-store-alt" />
          {{ $t("call-the-shop") }}
          <i class="fa fa-chevron-right" />
        </a>
      </div>

      <div v-if="driverContactable" class="notification">
        <p class="subtitle">
          <i class="fa fa-motorcycle" />
          Contact the Driver
        </p>
        <p>
          They may not pick up the phone while driving, but they'll call you
          back as soon as it's safe to do so
        </p>
        <p class="hint">
          <i>Best option if you're having difficulty finding your delivery</i>
        </p>

        <a class="button is-fullwidth is-link is-outlined" @click="callDriver">
          <i class="fa fa-motorcycle" />
          {{ $t("call-the-driver") }}
          <i class="fa fa-chevron-right" />
        </a>
      </div>

      <div class="notification" style="background-color: whitesmoke">
        <p class="subtitle">
          <i class="fa fa-headset" />
          Contact TUK Support
        </p>
        <p>
          Say it's regarding
          <span class="has-text-weight-medium">
            {{ t.data.business.name }} Order #{{ fullRef }}
            <!-- {{ t.data.ref }} -->
          </span>
          and share this info in the chat
          <span class="button is-small" @click="copyOrderURL">click to copy &nbsp;<i
              class="fa fa-copy has-text-link" /></span>
        </p>
        <p class="hint">
          <i>
            {{ $t("commerce-order.best-option-tuk-support") }}
          </i>
        </p>
        <a class="button has-text-grey is-fullwidth" @click="gotoChatSupport">
          <i class="fa fa-headset" />
          Chat with TUK Support
          <i class="fa fa-chevron-right" />
        </a>
      </div>

      <div class="notification" style="background-color: whitesmoke">
        <p class="subtitle">
          <i class="far fa-envelope" />
          Submit Email Feedback
        </p>
        <p>
          Put email subject:
          <span class="has-text-weight-medium">
            FEEDBACK {{ t.data.business.name }} Order #{{ fullRef }}
          </span>
          <span class="button is-small" @click="copyOrderURL">click to copy &nbsp;<i
              class="fa fa-copy has-text-link" /></span>
        </p>
        <p class="hint">
          <i>
            {{ $t("commerce-order.best-option-email-feedback") }}
          </i>
        </p>
        <a class="button has-text-grey is-fullwidth" @click="emailFeedback">
          <i class="far fa-envelope" />
          Submit Email Feedback
          <i class="fa fa-chevron-right" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CommerceOrderHelpWall",
  props: {
    t: Object,
    fullRef: String,
  },
  data() {
    return {};
  },
  computed: {
    shopContactable() {
      return true; // should be false if order is completed / cancelled and older than x hours
    },
    driverContactable() {
      if (!this.t.delivery) return false; // may not have driver yet
      return ["enroute", "alighted"].includes(this.t.delivery.state);
      // var states = [
      //   "initiated",
      //   "confirmed",
      //   "driver_arrived",
      //   "cancelled_by_driver",
      // ];
      // if (states.includes(this.t.delivery.state)) return false;
      // // also return false if cancelled alighted/no_show and older than x hours
      // return true;
    },
  },
  mounted() { },
  methods: {
    copyOrderURL() {
      var url = window.location.href;
      this.$copyText(url);
      this.infoToast(`Copied order details to clipboard`);
    },
    emailFeedback() {
      var email = "info@tukapp.co";
      var msg = `Opening email app... <br>Email to ${email}`
      this.infoToast(msg, "top", 6000)
      var subject = `FEEDBACK ${this.t.data.business.name} Order #${this.fullRef}`;
      window.location.href = `mailto:${email}?subject=${subject}`;
    },
    gotoChatSupport() {
      this.sendEmailCommerceOrderSupport("🦜 TUK Support");
      this.copyOrderURL();
      this.infoToast("Opening chat now...");
      setTimeout(() => {
        // window.open("https://m.me/tukapp", "_blank");
        this.contactFBMessengerSupport();
      }, 500);
    },
    callShop() {
      this.sendEmailCommerceOrderSupport("🏪 Shop Support");
      this.callPhoneNumber(this.t.business.data.phone_number);
    },
    callDriver() {
      this.sendEmailCommerceOrderSupport("🛵 Driver Support");
      this.callPhoneNumber(this.t.delivery.driver.phone_number);
    },
    sendEmailCommerceOrderSupport(supportType) {
      var t = this.t;
      var obj = {
        topic: "commerce_order_support",
        type: "commerce_order_support",
        user_id: this.$store.state.user.id,
        uuid: this.$store.getters.getUUID,
        phone_number: this.$store.getters.phoneNumber,
        name: this.$store.getters.realName,
        support_type: supportType,
        order: `${t.data.business.name} #${t.data.ref}`,
        app: process.env.VUE_APP_TITLE,
      };
      this.$store.dispatch("sendEmail", obj).catch((err) => console.error(err));
      var msg = `🎧 [ ${supportType} ] ${t.data.business.name} #${t.data.ref} 🙋🏻 ${this.$store.getters.realName}`;
      this.sendSuperuserNotification(msg);
    },
  },
};
</script>

<style scoped>
.commerce-order-help-wall {
  position: absolute;
  /* bottom: 0; */
  /* height: calc(100vh - 184px); */
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  background-color: whitesmoke;
  z-index: 3;
  text-align: left;
  padding: 12px;
  top: 0;
  /* padding-bottom: 40px; */
  overflow: scroll;
  max-width: 700px;
  margin: auto;
}

.scroll {
  height: 100%;
  overflow: scroll;
  padding-bottom: 20px;
}

.header {
  /* padding: 0 12px; */
  padding-left: 6px;
  padding-bottom: 4px;
  margin-bottom: 10px;
  margin-top: 4px;
  font-size: 1.1em;
}

.notification {
  margin-bottom: 12px;
  padding: 12px;
  border: 1px solid #ddd;
  background-color: white;
}

.notification p {
  margin-bottom: 8px;
}

.fa,
.far {
  margin-right: 6px;
}

.fa-chevron-right {
  margin-left: 6px;
}

.hint {
  font-weight: 500;
  font-size: 0.8em;
}

/* .border-blue {
  border: 1px solid var(--info);
} */
</style>